const toNegative = (v?: number) => (v === undefined ? undefined : v * -1);

export default toNegative;
